import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderInfo from '../../../../Components/Common/HeaderInfo';
import asiTitle from '../../../../asi.json';

function AsiScheduleMainMenu() {
  const [headerData, setHeaderData] = useState({
    despatchSlNo: '',
    permanentSlNo: '',
    companyName: ''
  });
  const navigate = useNavigate();

  const menuItems = [
    'Fixed Assets',
    'Balance Sheet',
    'Profit and Loss Account',
    'Employment and Labour Cost',
    'Input Items (indigenous)',
    'Input Items (imported)',
    'Products and By-products',
    'ICT Usage and Energy Conservation',
    'Particulars of Field Operations',
    'Validation',
    'Reports'
  ];

  useEffect(() => {
    const fetchDataFromBalanceSheet = () => {
      try {
        const balanceSheetData = localStorage.getItem('balanceSheetFormData');

        if (balanceSheetData) {
          const parsedData = JSON.parse(balanceSheetData);

          setHeaderData({
            despatchSlNo: parsedData.dslNo || '',
            permanentSlNo: parsedData.pslNo || '',
            companyName: parsedData.nameUnit || ''
          });
        } else {
          console.log('No balanceSheet data found in localStorage');
          setHeaderData({
            despatchSlNo: 'DSL No. not set',
            permanentSlNo: 'PSL No. not set',
            companyName: 'Company name not set'
          });
        }
      } catch (error) {
        console.error('Error fetching data from localStorage:', error);
        setHeaderData({
          despatchSlNo: 'Error loading data',
          permanentSlNo: 'Error loading data',
          companyName: 'Error loading data'
        });
      }
    };

    fetchDataFromBalanceSheet();
  }, []);

  const handleHeaderDataChange = (field, value) => {
    setHeaderData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleMenuClick = (item) => {
    console.log('Navigating to:', item);

    if (item === 'Fixed Assets') {
      navigate('/fixedAssets');
    } else if (item === 'Balance Sheet') {
      navigate('/balanceSheetData');
    } else if (item === 'Profit and Loss Account') {
      navigate('/profitAndLossAccount');
    } else if (item === 'Employment and Labour Cost') {
      navigate('/employmentAndLabourCost');
    } else if (item === 'Input Items (indigenous)') {
      navigate('/input-items');
    } else if (item === 'Input Items (imported)') {
      navigate('/input-items-imported');
    } else if (item === 'Products and By-products') {
      navigate('/products-and-by-products');
    } else if (item === 'ICT Usage and Energy Conservation') {
      navigate('/ict-usage-energy-conservation');
    } else if (item === 'Particulars of Field Operations') {
      navigate('/particulars-of-field-operations');
    } else if (item === 'Validation') {
      navigate('/validation');
    } else if (item === 'Reports') {
      navigate('/report-selection');
    }
  };

  const handleCancel = () => {
    navigate('/balanceSheet');
  };

  const storedLanguage = localStorage.getItem('language');


  return (
    <>
      <style>
        {`
          .menu-item:hover {
            background-color: #f8f9fa !important;
            border-color: #1976d2 !important;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2) !important;
          }
          .menu-item:active {
            transform: translateY(0);
            box-shadow: 0 2px 6px rgba(25, 118, 210, 0.15) !important;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        {/* <div className="card mx-3 mb-3">
          <div className="card-body pb-1" style={{ backgroundColor: '#e3f2fd', border: 'none' }}>
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="d-flex align-items-center">
                  <i className="fa fa-file-text-o me-2" style={{ fontSize: '24px', color: '#1976d2' }}></i>
                  <h4 className="page_heading mb-0">
                    ASI Schedule Main Menu
                  </h4>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                      Dispatch Number (DSL No.):
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={headerData.despatchSlNo}
                      onChange={(e) => handleHeaderDataChange('despatchSlNo', e.target.value)}
                      style={{ backgroundColor: '#f5f5f5', border: '1px solid #ddd', fontSize: '14px' }}
                      readOnly
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                      Permanent Sl no. (PSL No.):
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={headerData.permanentSlNo}
                      onChange={(e) => handleHeaderDataChange('permanentSlNo', e.target.value)}
                      style={{ backgroundColor: '#f5f5f5', border: '1px solid #ddd', fontSize: '14px' }}
                      readOnly
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                      Name of Company:
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={headerData.companyName}
                      onChange={(e) => handleHeaderDataChange('companyName', e.target.value)}
                      style={{ backgroundColor: '#f5f5f5', border: '1px solid #ddd', fontSize: '14px' }}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <HeaderInfo
          dispatchSlNo={headerData.despatchSlNo}
          permanentSlNo={headerData.permanentSlNo}
          companyName={headerData.companyName}
          companyPlaceholder="Enter Name of Company"
          showBlockCType={false}
          defaultBlockCType="netBlock"
          includeTableStyles={true}
        /> */}

        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading border-bottom-0">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.MAIN_MENU : asiTitle.en.MAIN_MENU }} />
              </h4>

              <div className="col-md-4 mb-3">
                <label className="fw-bold">Despatch Sl No: </label>
                <span className="ms-2">{headerData.despatchSlNo}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label className="fw-bold">Permanent Sl No: </label>
                <span className="ms-2">{headerData.permanentSlNo}</span>
              </div>

              <div className="col-md-4 mb-3">
                <label className="fw-bold">Name of Company: </label>
                <span className="ms-2">{headerData.companyName}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="card mx-3 mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="menu-items-container" style={{ maxWidth: '800px', margin: '0 auto' }}>
                  {menuItems.map((item, index) => (
                    <div
                      key={index}
                      className="menu-item d-flex align-items-center mb-3"
                      style={{
                        padding: '16px 20px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                      onClick={() => handleMenuClick(item)}
                    >
                      <div className="d-flex align-items-center w-100">
                        <i
                          className="fa fa-chevron-right me-3"
                          style={{
                            color: index >= menuItems.length - 2 ? '#ff9800' : 'rgb(21 22 22)',
                            fontSize: '14px',
                            transition: 'transform 0.3s ease'
                          }}
                        ></i>
                        <span
                          style={{
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: '500',
                            color: index >= menuItems.length - 2 ? '#ff9800' : 'rgb(21 22 22)',
                            flex: 1,
                            userSelect: 'none'
                          }}
                        >
                          {item}
                        </span>
                        <i
                          className="fa fa-arrow-right ms-2"
                          style={{
                            color: index >= menuItems.length - 2 ? '#ff9800' : 'rgb(21 22 22)',
                            fontSize: '12px',
                            opacity: '0.7'
                          }}
                        ></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => {
                localStorage.setItem('fromAsiScheduleMainMenu', 'true');
                navigate('/balanceSheet');
              }}
            >
              <i className="fa fa-angle-left me-1"></i>
              Previous
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/fixedAssets')}
            >
              Next
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AsiScheduleMainMenu; 
